import AuthHero from "@/components/auth/AuthHero";
import AuthForm from "@/components/auth/AuthForm";

export default function Auth() {
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      <AuthHero />
      <div className="flex items-center justify-center p-6 sm:p-10">
        <AuthForm />
      </div>
    </div>
  );
}
